const URL_SCHEME = 'unitvictor';

export class Deeplinks {

    private clickBind = this.handleClick.bind(this);
    private blurBind = this.handleWindowBlur.bind(this);

    private urlSchemeWasOpened = false;

    private originalHref: string;

    constructor(protected element: HTMLAnchorElement) {
        const isMobile = (/android|iphone|ipad|ipod/i).test(navigator.userAgent);
        if (isMobile) {
            this.originalHref = element.getAttribute('href');
            const deeplinkHref = `${URL_SCHEME}:/${this.originalHref.split(location.origin).join('')}`;
            element.setAttribute('href', deeplinkHref);
            element.addEventListener('click', this.clickBind);
        }
    }

    private handleClick(): void {
        this.urlSchemeWasOpened = false;
        window.addEventListener('blur', this.blurBind);

        setTimeout(() => {
            if (! this.urlSchemeWasOpened) {
                console.log('Deeplink was not opened within 500ms. Navigating to the original URL...');
                if (this.element.getAttribute('target') === '_blank') {
                    window.open(this.originalHref);
                } else {
                    location.href = this.originalHref;
                }
            }

            window.removeEventListener('blur', this.blurBind);
        }, 500);
    }

    private handleWindowBlur(): void {
        console.log('blur');
        this.urlSchemeWasOpened = true;
    }

}
